<template>
  <div>
    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>
      <el-button-group v-if="tableDisplay" class="float-right">
        <a @click="Yazdir" class="el-button YeniBtn el-button--primary el-button--small"
        ><i class="feather-printer"></i> Yazdır
        </a>
      </el-button-group>
    </div>
    <div class="icerik" style="height: calc(100vh - 120px);">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">
          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">
            <el-col :span="5">
              <el-form-item label="Site / Bina" prop="Bina_id">
                <el-select v-model="Form.Bina_id" filterable>
                  <el-option-group
                    label="Site Listesi">
                    <el-option
                      v-for="item in Siteler"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                  <el-option-group
                    label="Bina Listesi">
                    <el-option
                      v-for="item in Binalar"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="Rapor Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item class="Tooltip" label="Kasa Detay" prop="Kasa">
                <el-tooltip class="item" effect="dark" content="Kasalardaki bakiyeyi getirir" placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-switch v-model="Form.Kasa"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item class="Tooltip" label="Alacak ve Borç" prop="Alacak">
                <el-tooltip class="item" effect="dark" content="Alacak ve borç bakiyesini getirir." placement="top">
                  <i class="el-icon-info text-primary cursor-pointer"></i>
                </el-tooltip>
                <el-switch v-model="Form.Alacak"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="6">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
        <el-col :span="24" v-if="!tableDisplay">
          <el-alert
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
        </el-col>
        <div v-if="tableDisplay">
          <h5 class="text-center">{{TextBinaAdi}}</h5>
          <h6 class="text-center">{{TextTarih}} Tarihli Gelir Gider Dökümü</h6>
          <el-row :gutter="24">
            <el-col :span="12">
              <table class="table table-xs table-bilanco table-siyah">
                <thead>
                <tr>
                  <th colspan="3">GELİR</th>
                </tr>
                <tr>
                  <th>Gelir Türü</th>
                  <th class="text-right">Zam</th>
                  <th class="text-right" width="100">Tutar</th>
                </tr>
                </thead>
                <tbody v-for="g in tableData.Gelir">
                <tr>
                  <td>{{g.Adi}}</td>
                  <td class="text-right">{{g.Zam}}</td>
                  <td class="text-right">{{g.Tutar}}</td>
                </tr>
                <tr class="tr-xs" v-for="ga in g.children">
                  <td>{{ga.Adi}}</td>
                  <td class="text-right">{{ga.Zam}}</td>
                  <td class="text-right">{{ga.Tutar}}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                  <th>GELİR TOPLAM</th>
                  <th class="text-right">{{tableData.AltToplam.Zam}}</th>
                  <th class="text-right">{{tableData.AltToplam.Gelir}}</th>
                </tr>
                </tfoot>
              </table>
            </el-col>
            <el-col :span="12">
              <table class="table table-xs table-bilanco table-siyah">
                <thead>
                <tr>
                  <th colspan="2">GİDER</th>
                </tr>
                <tr>
                  <th>Gider Türü</th>
                  <th class="text-right">Tutar</th>
                </tr>
                </thead>
                <tbody v-for="g in tableData.Gider">
                <tr>
                  <td>{{g.Adi}}</td>
                  <td class="text-right">{{g.Tutar}}</td>
                </tr>
                <tr class="tr-xs" v-for="ga in g.children">
                  <td>{{ga.Adi}}</td>
                  <td class="text-right">{{ga.Tutar}}</td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                  <th>GİDER TOPLAM</th>
                  <th class="text-right">{{tableData.AltToplam.Gider}}</th>
                </tr>
                </tfoot>
              </table>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="6">
              <table class="table table-xs table-sari">
                <thead>
                <tr>
                  <th>KASA BLOKE</th>
                  <th class="text-right">{{tableData.AltToplam.Bloke}}</th>
                </tr>
                </thead>
              </table>
            </el-col>
            <el-col :span="6">
              <table class="table table-xs table-mavi">
                <thead>
                <tr>
                  <th>TAZMİNAT FONU</th>
                  <th class="text-right">{{tableData.AltToplam.Kidem}}</th>
                </tr>
                </thead>
              </table>
            </el-col>
            <el-col :span="12">
              <table class="table table-xs table-yesil" :class="Form.Kasa==true?'mb-0':''">
                <thead>
                <tr>
                  <th>KULLANILABİLİR KASA BAKİYESİ</th>
                  <th class="text-right">{{tableData.AltToplam.Para}}</th>
                </tr>
                </thead>
              </table>
              <table v-if="Form.Kasa" class="table alttable table-xs mt-0 mb-3 table-yesil table-bilanco"
                     style="border-top:0 !important">
                <thead>
                <tr>
                  <th>Kasa Adı</th>
                  <th class="text-right">Bakiye</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="k in kasaData">
                  <td>{{k.Adi}}</td>
                  <td class="text-right">{{k.Bakiye}}</td>
                </tr>
                </tbody>
              </table>

            </el-col>
            <el-col v-if="Form.Alacak" :span="12">
              <table class="table table-xs table-mavi">
                <thead>
                <tr>
                  <th>ALACAK BAKİYESİ</th>
                  <th class="text-right">{{tableData.AltToplam.Alacak}}</th>
                </tr>
                </thead>
              </table>
            </el-col>
            <el-col v-if="Form.Alacak" :span="12">
              <table class="table table-xs table-kirmizi">
                <thead>
                <tr>
                  <th>BORÇ BAKİYESİ</th>
                  <th class="text-right">{{tableData.AltToplam.Borc}}</th>
                </tr>
                </thead>
              </table>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Yukleniyor from "../../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        Binalar: [],
        Siteler: [],
        KasaHeight: '200px',
        lo: false,
        Yetki: false,
        Kaydet: false,
        Sayfa: {
          Adi: 'Kasa Bilanço',
          ButtonAdi: 'Uygula',
          FiltreAdi: 'Filtreleme',
        },
        FormHata: {
          Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        Form: {
          Bina_id: null,
          Tarih: [],
          Kasa: false,
          Alacak: false

        },
        tableData: null,
        kasaData: null,
        ExcelData: null,
        tableDisplay: false,
      }
    },
    methods: {
      Getir() {
        this.$refs['RaporForm'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Post", {...this.Form, path: 'raporlama/kasa/bilanco'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.tableData = response.tableData;
                  this.ExcelData = response.ExcelData;
                  this.kasaData = response.kasaData;
                  if (this.tableData) this.tableDisplay = true;
                  this.TextBinaAdi = response.Bilgi.BinaAdi;
                  this.TextTarih = response.Bilgi.Tarih;

                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        })
      },
      Yazdir() {
        window.print()
      },
      SayfaYukle() {
        this.$store.dispatch("Get", {path: 'muhasebe/list/bina'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Binalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'muhasebe/list/site'})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Siteler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    created() {
      this.SayfaYukle();
      this.Yetki = this.$store.getters.Yetki.raporlama == 2 ? true : false;
      var Gun = new Date();
      this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
      this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
      if (this.$store.getters.BinaBilgi) {
        this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/kasa/bilanco.vue